"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Event = void 0;
var Event;
(function (Event) {
    Event[Event["SPACE_INITIALIZED"] = 0] = "SPACE_INITIALIZED";
    Event[Event["ADD_TICKER"] = 1] = "ADD_TICKER";
    Event[Event["LOADING_CONTROLLER_END"] = 2] = "LOADING_CONTROLLER_END";
    // Space interactions
    Event[Event["SPACE_POINTER_MOVE"] = 3] = "SPACE_POINTER_MOVE";
    Event[Event["SPACE_POINTER_OUT"] = 4] = "SPACE_POINTER_OUT";
    Event[Event["SPACE_BUTTON_HOVER"] = 5] = "SPACE_BUTTON_HOVER";
    Event[Event["SPACE_BUTTON_OUT"] = 6] = "SPACE_BUTTON_OUT";
    Event[Event["START_BUTTON_CLICK"] = 7] = "START_BUTTON_CLICK";
})(Event = exports.Event || (exports.Event = {}));
